import React, { useState } from 'react'
import { shouldShowBookingIn, getBookingButtonText } from '../config/booking';
import { isContactInfoEnabled, shouldShowContactFeature, getContactInfo, getContactAlternativeMessage } from '../config/contact';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    message: ''
  })

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    })
  }

    const handleSubmit = (e) => {
    e.preventDefault();
    
    // Handle form submission here
    setIsSubmitted(true);
    
    // Reset form after 3 seconds
    setTimeout(() => {
      setIsSubmitted(false);
      setFormData({
        name: '',
        email: '',
        phone: '',
        message: ''
      });
    }, 3000);
  };

  const services = [
    'Panchakarma Therapy',
    'Abhyanga Massage',
    'Shirodhara',
    'Herbal Steam Bath',
    'Ayurvedic Consultation',
    'Yoga & Meditation',
    'Other'
  ]

  return (
    <section id="contact" className="py-20 bg-gradient-to-br from-green-50 to-brown-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        {isContactInfoEnabled() && (
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Get in <span className="text-green-600">Touch</span> with <span className="text-brown-600">Us</span>
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Ready to start your journey to wellness? Contact us today to schedule your consultation 
              or learn more about our Ayurvedic treatments.
            </p>
          </div>
        )}

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Contact Information */}
          {shouldShowContactFeature('showVisitClinic') && (
            <div className="space-y-8">
            <div>
              <h3 className="text-3xl font-bold text-gray-900 mb-6">Visit Our Clinic</h3>
              <div className="space-y-6">
                {/* Address */}
                {shouldShowContactFeature('showAddress') && (
                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center flex-shrink-0">
                      <span className="text-green-600 text-xl">📍</span>
                    </div>
                    <div>
                      <h4 className="text-lg font-semibold text-gray-900 mb-1">Address</h4>
                      <p className="text-gray-600">
                        {getContactInfo('address', 'street')}<br />
                        {getContactInfo('address', 'city')}<br />
                        {getContactInfo('address', 'country')}
                      </p>
                    </div>
                  </div>
                )}

                {/* Phone */}
                {shouldShowContactFeature('showPhone') && (
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-brown-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <span className="text-brown-600 text-xl">📞</span>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold text-gray-900 mb-1">Phone</h4>
                    <p className="text-gray-600">
                      {getContactInfo('phone', 'primary')}<br />
                      {getContactInfo('phone', 'secondary')}
                    </p>
                  </div>
                </div>
                )}

                {/* Email */}
                {shouldShowContactFeature('showEmail') && (
                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center flex-shrink-0">
                      <span className="text-green-600 text-xl">✉️</span>
                    </div>
                    <div>
                      <h4 className="text-lg font-semibold text-gray-900 mb-1">Email</h4>
                    <p className="text-gray-600">
                      {getContactInfo('email', 'info')}<br />
                      {getContactInfo('email', 'appointments')}
                    </p>
                  </div>
                </div>
                )}

                {/* Hours */}
                {shouldShowContactFeature('showHours') && (
                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 bg-brown-100 rounded-lg flex items-center justify-center flex-shrink-0">
                      <span className="text-brown-600 text-xl">🕐</span>
                    </div>
                    <div>
                      <h4 className="text-lg font-semibold text-gray-900 mb-1">Opening Hours</h4>
                      <div className="text-gray-600 space-y-1">
                        <p>{getContactInfo('hours', 'weekdays')}</p>
                        <p>{getContactInfo('hours', 'weekend')}</p>
                        <p className="text-green-600 font-medium">{getContactInfo('hours', 'emergency')}</p>
                    </div>
                  </div>
                </div>
                )}

                {/* Social Links */}
                {shouldShowContactFeature('showSocialLinks') && (
                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center flex-shrink-0">
                      <span className="text-green-600 text-xl">🌐</span>
                    </div>
                    <div>
                      <h4 className="text-lg font-semibold text-gray-900 mb-1">Follow Us</h4>
                      <div className="flex space-x-4">
                        <a
                          href={getContactInfo('social', 'instagram')}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="flex items-center space-x-2 text-gray-600 hover:text-pink-600 transition-colors duration-200"
                        >
                          <span className="text-lg">📷</span>
                          <span className="text-sm font-medium">Instagram</span>
                        </a>
                        <a
                          href={getContactInfo('social', 'youtube')}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="flex items-center space-x-2 text-gray-600 hover:text-red-600 transition-colors duration-200"
                        >
                          <div className="w-6 h-4 bg-red-600 rounded-sm flex items-center justify-center">
                            <span className="text-white text-xs font-bold ml-0.5">▶</span>
                          </div>
                          <span className="text-sm font-medium">YouTube</span>
                        </a>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* Map placeholder */}
            {shouldShowContactFeature('showMap') && (
              <div className="bg-white rounded-xl shadow-lg p-4">
                <div className="w-full h-64 bg-gradient-to-br from-green-100 to-brown-100 rounded-lg flex items-center justify-center">
                  <div className="text-center">
                    <span className="text-4xl mb-2 block">🗺️</span>
                    <p className="text-gray-600 font-medium">Interactive Map</p>
                    <p className="text-sm text-gray-500">Click to view location</p>
                </div>
              </div>
            </div>
            )}
          </div>
          )}

          {/* Contact Form */}
          {shouldShowContactFeature('showContactForm') && (
            <div className="bg-white rounded-2xl shadow-xl p-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">
                {shouldShowBookingIn('Contact') ? 'Book Your Consultation' : 'Contact Us'}
              </h3>
            <form onSubmit={handleSubmit} className="space-y-6">
              {/* Name */}
              <div>
                <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">
                  Full Name *
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent transition-colors duration-200"
                  placeholder="Enter your full name"
                />
              </div>

              {/* Email */}
              <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                  Email Address *
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent transition-colors duration-200"
                  placeholder="Enter your email address"
                />
              </div>

              {/* Phone */}
              <div>
                <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-2">
                  Phone Number *
                </label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent transition-colors duration-200"
                  placeholder="Enter your phone number"
                />
              </div>

              {/* Service */}
              <div>
                <label htmlFor="service" className="block text-sm font-medium text-gray-700 mb-2">
                  Service of Interest
                </label>
                <select
                  id="service"
                  name="service"
                  value={formData.service}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent transition-colors duration-200"
                >
                  <option value="">Select a service</option>
                  {services.map((service, index) => (
                    <option key={index} value={service}>{service}</option>
                  ))}
                </select>
              </div>

              {/* Message */}
              <div>
                <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">
                  Message
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  rows={4}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent transition-colors duration-200"
                  placeholder="Tell us about your health concerns or questions..."
                ></textarea>
              </div>

              {/* Submit Button */}
              <button
                type="submit"
                className="w-full bg-gradient-green text-white py-4 px-6 rounded-lg font-semibold text-lg hover:bg-green-700 transition-colors duration-200 shadow-lg hover:shadow-xl"
              >
                {shouldShowBookingIn('Contact') ? 'Send Message & Book Consultation' : 'Send Message'}
              </button>
            </form>

            {/* Additional Info */}
            <div className="mt-6 p-4 bg-green-50 rounded-lg">
              <p className="text-sm text-green-700">
                <span className="font-medium">Quick Response:</span> We typically respond within 2-4 hours during business hours. 
                For urgent matters, please call us directly.
              </p>
            </div>
          </div>
          )}
        </div>
      </div>
    </section>
  )
}

export default Contact
